import { render, staticRenderFns } from "./monitor-filter.vue?vue&type=template&id=2488cdea"
import script from "./monitor-filter.vue?vue&type=script&lang=js"
export * from "./monitor-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports